import {BrowserRouter as Router,Route,Switch} from 'react-router-dom'
import App from './App'
import Error from './404'
import React from 'react'
import ViewStorage from './pages/ViewStorage'
import { contentPath, modules } from './config/pages'
import Forbidden from './pages/Forbidden'
import ViewSettings from './pages/ViewSettings'
import ViewContacts from './pages/ViewContacts'

// Manufacturing Pages
import ViewTemplates from './pages/manufacturing/ViewTemplates'
import CreateTemplate from './pages/manufacturing/CreateTemplate'
import EditTemplate from './pages/manufacturing/EditTemplate'
import ViewOrders from './pages/manufacturing/ViewOrders'
import CreateOrder from './pages/manufacturing/CreateOrder'
import EditOrder from './pages/manufacturing/EditOrder'
import ViewCycles from './pages/manufacturing/ViewCycles'
import CreateCycle from './pages/manufacturing/CreateCycle'
import EditCycle from './pages/manufacturing/EditCycle'
import ViewCycle from './pages/manufacturing/ViewCycle'

function Routes(){
  return (
    
    <Router>
      <Switch>
        <Route exact path="/" component={App}/> 
        <Route exact path="/sorry" component={Forbidden}/> 
        <Route exact path={contentPath[modules.StorageItemList]} component={ViewStorage}/> 
        <Route exact path={contentPath[modules.Settings]} component={ViewSettings}/>  


        {/* Manufacturing */}
        <Route exact path={contentPath[modules.TemplatesList]} component={ViewTemplates}/>  
        <Route exact path={contentPath[modules.CreateTemplate]} component={CreateTemplate}/>  
        <Route exact path={contentPath[modules.EditTemplate]} component={EditTemplate}/>  
        <Route exact path={contentPath[modules.OrdersList]} component={ViewOrders}/>  
        <Route exact path={contentPath[modules.CreateOrder]} component={CreateOrder}/>  
        <Route exact path={contentPath[modules.EditOrder]} component={EditOrder}/>  
        <Route exact path={contentPath[modules.CyclesList]} component={ViewCycles}/>  
        <Route exact path={contentPath[modules.CreateCycle]} component={CreateCycle}/>  
        <Route exact path={contentPath[modules.EditCycle]} component={EditCycle}/>  
        <Route exact path={contentPath[modules.ViewCycle]} component={ViewCycle}/>  
        <Route exact path={contentPath[modules.ContactList]} component={ViewContacts}/>

        <Route component={Error} />
      </Switch>
    </Router>
  )
}

export default Routes